/*
 * @Author: changcheng
 * @LastEditTime: 2023-03-03 10:01:39
 */
import { CountryCaseDiscussion } from "./country/index";
export default function CaseDisussion() {
  return (
    <div>
      <CountryCaseDiscussion />
    </div>
  );
}
